import PropTypes from 'prop-types';
import { Link as InertiaLink, usePage } from '@inertiajs/react';
import { Box, Typography } from '@mui/material';
import { getQueryParam } from '../../utils/urlFunctions';

function NoResults({ handleLinkClick, type = 'results' }) {
  const { url } = usePage();
  const searchQuery = getQueryParam(url, 'search');

  const products_link = (
    <InertiaLink href="/products" onClick={handleLinkClick}>
      products
    </InertiaLink>
  );

  const resources_link = (
    <InertiaLink href="/resources" onClick={handleLinkClick}>
      resources
    </InertiaLink>
  );

  const links =
    type === 'products'
      ? [products_link]
      : type === 'resources'
      ? [resources_link]
      : [products_link, ' or ', resources_link];

  return (
    <Box mb={3}>
      <Typography variant="h5" mb={1}>
        No {type} found for &quot;{searchQuery}&quot;
      </Typography>
      <Typography variant="h5">Please try another query or browse {links}.</Typography>
    </Box>
  );
}

NoResults.propTypes = {
  handleLinkClick: PropTypes.func,
};

export default NoResults;
